import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { Close, Refresh } from '@mui/icons-material';
import styles from './ExecutionLogsDrawer.module.scss';

const ExecutionLogsDrawer = ({
  open,
  onClose,
  title,
  subtitle,
  loading = false,
  onRefresh,
  onClear,
  refreshDisabled = false,
  clearDisabled = false,
  clearLabel = 'Clear',
  refreshTitle = 'Get latest logs',
  children,
}) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} className={styles.drawer}>
      <Box className={styles.header}>
        <Box className={styles.headerText}>
          <Typography variant="h6" component="h2">{title}</Typography>
          {subtitle && (
            <Typography variant="caption" color="text.secondary">{subtitle}</Typography>
          )}
        </Box>
        <Box className={styles.actions}>
          {onRefresh && (
            <Tooltip title={refreshTitle}>
              <span>
                <IconButton
                  onClick={onRefresh}
                  disabled={loading || refreshDisabled}
                  className={styles.iconButton}
                  size="small"
                  type="button"
                >
                  {loading ? <CircularProgress size={18} color="inherit" /> : <Refresh fontSize="small" />}
                </IconButton>
              </span>
            </Tooltip>
          )}
          {onClear && (
            <Button
              size="small"
              onClick={onClear}
              disabled={clearDisabled || loading}
              className={styles.clearButton}
              type="button"
            >
              {clearLabel}
            </Button>
          )}
          <IconButton onClick={onClose} className={styles.iconButton} size="small" type="button" aria-label="Close">
            <Close />
          </IconButton>
        </Box>
      </Box>
      <Box className={styles.body}>{children}</Box>
    </Drawer>
  );
};

export default ExecutionLogsDrawer;
